module.exports = __webpack_public_path__ + "static/media/image8.34a6c700.png";